import React, {useState} from 'react';
import {InputNumber} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import TimeSeriesLineChart from '../../../../components/admin/reports/charts/TimeSeriesLineChart';
import {dateFormat} from '../../../../utils/utils';

export default function GrowthChart({dateFrom, dateTo}) {
    const [activeWindowDays, setActiveWindowDays] = useState(90);
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_GROWTH,
        params: {date_from: dateFrom, date_to: dateTo, active_window_days: activeWindowDays},
        dataDefault: {},
    });
    const series = data?.series || [];

    return (
        <ReportChartCard
            title="Evolução de Pacientes Ativos"
            loading={isLoading}
            isEmpty={!series.length}
            extra={
                <InputNumber
                    size="small"
                    min={1}
                    addonBefore="Janela (dias)"
                    value={activeWindowDays}
                    onChange={(value) => setActiveWindowDays(value || 90)}
                    style={{width: 180}}
                />
            }
        >
            <TimeSeriesLineChart
                data={series}
                dataKey="active_patients"
                periodFormatter={(value) => dateFormat(value, 'MMM/YY')}
                tooltipFields={[
                    {key: 'active_patients', label: 'Ativos'},
                    {key: 'pct_change', label: 'Variação (%)', formatter: (v) => (v == null ? '-' : `${v}%`)},
                ]}
            />
        </ReportChartCard>
    );
}
